"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRecaptureState = void 0;
exports.defaultRecaptureState = {
    flavor: 'recap3',
    isActive: false,
    t: {
        heading: 'Don\'t Miss Out!',
        // tslint:disable-next-line:max-line-length
        caption: 'Get our super-secret email updates and be the first to know about new homes and price changes!​',
        save: 'Save this Search',
        cancel: 'No, Thanks',
    },
};
